/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUnrecognizedUavPlatform
 */
export interface OutputUnrecognizedUavPlatform {
    /**
     * Count — кількість заявок у групі.
     * @type {number}
     * @memberof OutputUnrecognizedUavPlatform
     */
    count?: number;
    /**
     * LastSeen — час останньої появи (created_at найсвіжішої заявки групи).
     * @type {string}
     * @memberof OutputUnrecognizedUavPlatform
     */
    lastSeen?: string;
    /**
     * MissionIds — приклади id заявок (до 5), щоб адмін міг перевірити першоджерело.
     * @type {Array<number>}
     * @memberof OutputUnrecognizedUavPlatform
     */
    missionIds?: Array<number>;
    /**
     * Name — репрезентативна (найчастіша) сира назва платформи в групі, готова до предзаповнення.
     * @type {string}
     * @memberof OutputUnrecognizedUavPlatform
     */
    name?: string;
    /**
     * Variants — до 3 найчастіших сирих варіантів написання (для контексту, напр. "Vector R20"/"Vector r20").
     * @type {Array<string>}
     * @memberof OutputUnrecognizedUavPlatform
     */
    variants?: Array<string>;
}

/**
 * Check if a given object implements the OutputUnrecognizedUavPlatform interface.
 */
export function instanceOfOutputUnrecognizedUavPlatform(value: object): boolean {
    return true;
}

export function OutputUnrecognizedUavPlatformFromJSON(json: any): OutputUnrecognizedUavPlatform {
    return OutputUnrecognizedUavPlatformFromJSONTyped(json, false);
}

export function OutputUnrecognizedUavPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUnrecognizedUavPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
        'lastSeen': json['lastSeen'] == null ? undefined : json['lastSeen'],
        'missionIds': json['missionIds'] == null ? undefined : json['missionIds'],
        'name': json['name'] == null ? undefined : json['name'],
        'variants': json['variants'] == null ? undefined : json['variants'],
    };
}

export function OutputUnrecognizedUavPlatformToJSON(value?: OutputUnrecognizedUavPlatform | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'lastSeen': value['lastSeen'],
        'missionIds': value['missionIds'],
        'name': value['name'],
        'variants': value['variants'],
    };
}

